import styled from 'styled-components/macro';
import { Col, Row } from '@zendeskgarden/react-grid';

export const EndFinishDetailsCard = styled('div')`
  ${(props) =>
    props.listingsRefactor
      ? 'padding-top: 40px; padding-left: 40px;'
      : 'min-width: 100%; max-width: 100%;'};
  @media (max-width: 425px) {
    ${(props) =>
      props.listingsRefactor ? 'padding-top: 20px; padding-left: 20px;' : null}
  }
`;

export const AttributesCol = styled(Col)`
  margin-bottom: 30px;
  padding-right: 70px;
  @media (max-width: 650px) {
    margin-bottom: 0px;
  }
`;

export const DescriptionRow = styled(Row)`
  @media (max-width: 426px) {
    ${(props) => (props.listingsRefactor ? 'padding-top: 15px;' : null)};
  }
  ${(props) => (props.listingsRefactor ? 'padding-top: 30px;' : null)};
`;
